export const DEFAULT_GPT_QUESTION = 'What is CLIPr?';
